import { RESET_APP_STATE } from "./mutation-types";

export default {
  [RESET_APP_STATE](state, inDefaultState) {
    state = Object.assign({}, state, inDefaultState);
  }
};
